import API from '../../../../../services/api';

export const getBastidorByMatricula = async (data) => {
    return API.post('bastidores/get-bastidor', data).then(res => res.data);
}

export const getAllBastidores = async (data) => {
    return API.post('bastidores/get-all-bastidores', data).then(res => res.data);
}

export const getMoreInfoVehicle = async (ktype) => {
    return API.get(`bastidores/${ktype}/more-info`).then(res => res.data);
}
